<template>
  <main-layout>
    <b-loading :is-full-page="true" :active.sync="loading" />
    <div v-if="!loading">
      <h1 class="title">Modifica {{ product.code }}</h1>
      <product-form :item="product" />
    </div>
  </main-layout>
</template>

<script>
import { get, call } from "vuex-pathify"
import store from "@/store"

import ProductForm from "@/components/ProductForm.vue"
import MainLayout from "@/layouts/Main.vue"

export default {
  components: {
    ProductForm,
    MainLayout
  },
  data() {
    return {
      loading: true
    }
  },
  computed: {
    product: get("products/product")
  },
  async beforeRouteUpdate(to, from, next) {
    this.loading = true
    await this.fetchProduct(to.params.id)
    this.loading = false
    next()
  },
  beforeDestroy() {
    store.set("products/product", {})
  },
  async mounted() {
    this.loading = true
    await this.fetchProduct(this.$route.params.id)
    this.loading = false
  },
  methods: {
    fetchProduct: call("products/find")
  }
}
</script>

<style lang="sass" scoped>
nav
  margin-top: 2.1rem
.column.is-narrow:first-child
  padding-left: 0
</style>
